<template>
<v-container>
  <v-layout class="my-5">
    <v-flex xs12 sm8 offset-sm2>
      <v-card>
        <ImageDialog :imgUrl="selectedImage" :dialog="showDialog"></ImageDialog>
        <v-container grid-list-sm fluid>
          <v-layout row wrap>
            <v-flex v-for="img in project.galleryImages" :key="img" xs4>
              <v-card flat tile>
                <v-img :src="img" height="150px" @click="showImageDialog(img)"></v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-title primary-title>
          <div>
            <h3 class="headline my-2">{{project.title}}</h3>
            <div v-if="project.description">{{project.description}}</div>
            <h6 class="caption mt-2">zdjęcia: {{project.photograph}}</h6>
          </div>
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import ImageDialog from '../components/ImageDialog.vue';
import ProjectRepository from '../services/ProjectRepository';

const projectRepository = new ProjectRepository();

const getProject = function(id) {
  const arr = projectRepository.getProjects();
  for(let el of arr) {
    if (el.id === id) {
      return el;
    }
  }
  return {};
};

export default {
  components: {
    ImageDialog
  },
  data () {
    return {
      showDialog: false,
      project: getProject(this.$route.params.id),
      selectedImage: ""
    }
  },
  methods: {
    showImageDialog(img) {
      this.selectedImage = img;
      this.showDialog = true;
    }
  }
}
</script>
